import React, { FC, memo, ReactElement, useCallback } from 'react';
import { Contract, ContractItem } from 'entities/Contract';
import { useAcceptPriceRaise } from '../utils/hooks/useAcceptPriceRaise';

interface AcceptPriceRaiseProps {
  contract: Contract;
  newPrice: number;
  currentPrice?: number;
  contractItem?: Nullable<ContractItem>;
  priceRaiseDate?: string;
  contractItemPriceRaiseId?: string;
  action: ReactElement;
}

export const AcceptPriceRaise: FC<AcceptPriceRaiseProps> = memo((props) => {
  const { action, contract, newPrice, currentPrice, contractItem, priceRaiseDate, contractItemPriceRaiseId } = props;

  const { openAcceptPriceRaise, acceptPriceRaiseModal } = useAcceptPriceRaise();

  const openModal = useCallback((): void => {
    openAcceptPriceRaise({
      contract,
      newPrice,
      currentPrice,
      contractItem,
      priceRaiseDate,
      contractItemPriceRaiseId,
    });
  }, [contract, contractItem, contractItemPriceRaiseId, currentPrice, newPrice, openAcceptPriceRaise, priceRaiseDate]);

  return (
    <>
      {React.cloneElement(action, { onClick: openModal })}
      {acceptPriceRaiseModal}
    </>
  );
});
